var React = require('react');

function MemoryMatchCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeMiterlimit":"10","strokeWidth":"9.36","d":"m57.337 20.456-22.7 23.7-11.5-11","fill":"none","style":{"stroke":"#83a56d"},"data-name":"Group 284"}));
}

MemoryMatchCheck.defaultProps = {"data-name":"Layer 1","viewBox":"18.212 15.957 43.821 36.182"};

module.exports = MemoryMatchCheck;

MemoryMatchCheck.default = MemoryMatchCheck;
